module.exports = __webpack_public_path__ + "img/rote.05397533.svg";